import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

import api from 'api'
import config from 'config'

const httpLink = createHttpLink({ uri: `${api.baseUrl}/${api.unifiedAdmin}/graphql` })

const authLink = setContext(() => {
  const token = JSON.parse(localStorage.getItem(config.AUTH_TOKEN_KEY) || '{}')
  const { token_type, access_token } = token

  return {
    headers: {
      Authorization: `${token_type} ${access_token}`,
    },
  }
})

const link = authLink.concat(httpLink)

const apolloClient = new ApolloClient({
  cache: new InMemoryCache({ addTypename: false }),
  link,
})

export default apolloClient
